const modal = document.getElementById('recoverModal');
const closeBtn = document.querySelector('.modal-close');
const title = document.querySelector('#recoverModal h2');
const type_input = document.querySelector('#recoverModal input[name="type"]');
const email_input = document.querySelector('#recoverModal input[name="email"]');
const form = document.getElementById('recoverForm');
const recoverResponse = document.getElementById('recoverResponse');

const copyKey = () => {
    const key_dom = document.querySelector('.key');
    const key = key_dom.textContent;
    navigator.clipboard.writeText(key).then(() => {
        key_dom.classList.remove('flash'); // Reset animation
        void key_dom.offsetWidth; // Force reflow to restart animation
        key_dom.classList.add('flash');
    })
};

const openModal = (type) => {
    title.textContent = i18next.t('subscribe.recover.title', {processorName: type});
    modal.classList.add('open');
    type_input.value = type;
    recoverResponse.innerHTML = '';
};

const closeModal = () => {
    modal.classList.remove('open');
};

closeBtn.addEventListener('click', closeModal);
modal.addEventListener('click', (e) => {
    if (e.target === modal) closeModal();
});

form.addEventListener('submit', async (e) => {
    e.preventDefault();
    const email = email_input.value.trim();
    if (!email) return;
    const type = type_input.value.toLowerCase();

    const submitBtn = form.querySelector('button[type="submit"]');
    submitBtn.disabled = true;
    submitBtn.textContent = i18next.t('subscribe.recover.submit-sending');

    try {
        const res = await fetch('recover-'+type, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ email }),
        });

        const htmlContent = await res.text();

        recoverResponse.innerHTML = res.ok
            ? htmlContent
            : `<p style="color:red;">Error: ${res.status} ${res.statusText}</p>`;
        updateContent();
    } catch (err) {
        recoverResponse.innerHTML = `<p style="color:red;">Request failed: ${err.message}</p>`;
    } finally {
        submitBtn.disabled = false;
        submitBtn.textContent = i18next.t('subscribe.recover.submit');
    }
});